import { Box } from '@mui/material';
import { FunctionComponent, ReactNode, useEffect, useState } from 'react';
import { LoadingSpinner } from '../presentation-components/display-elements-components/loading-spinner';

export const LoadingPage: FunctionComponent<{ children: ReactNode, pageReady: boolean, disableDelay?: boolean, }> = ({ children, pageReady, disableDelay = false }) => {

  const [showLoadingSpinner, setShowLoadingSpinner] = useState<boolean>(false)

  useEffect(() => {
    if (!disableDelay) {
      setTimeout(() => {
        setShowLoadingSpinner(true)
      }, 1000)
    }
  }, [])

  return pageReady ? (
    <>{children}</>
  ) : showLoadingSpinner ? (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh', width: '100%' }}>
      <LoadingSpinner />
    </Box>
  ) : null;
}

